import _uniqueId from "lodash/uniqueId";


export var attachId = function (func) {
  return function () {
    return {
      mutations: func.apply(undefined, arguments),
      id: _uniqueId("throttledEvent")
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/es/helpers/event-handlers.js
// module id = 84
// module chunks = 1